import React from "react";
import {
  KeyboardDateTimePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import { FormControl } from "@material-ui/core";
import ValidationMessage from "../../../services/ValidationMessage";
import DateFnsUtils from "@date-io/date-fns";

export default function CustomDateAndTimePicker(props) {
  const { formControlProps, dateAndTimePickerProps, dateOnly, timeOnly } =
    props;

  return (
    <FormControl {...formControlProps}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {dateOnly ? (
          <DatePicker {...dateAndTimePickerProps} />
        ) : timeOnly ? (
          <KeyboardTimePicker {...dateAndTimePickerProps} />
        ) : (
          <KeyboardDateTimePicker {...dateAndTimePickerProps} />
        )}
      </MuiPickersUtilsProvider>
      {dateAndTimePickerProps.required ? (
        <ValidationMessage name={dateAndTimePickerProps.name} />
      ) : (
        ""
      )}
    </FormControl>
  );
}
